export default "__VITE_PUBLIC_ASSET__c66c3b79__"